import axios from 'axios';
import { API_URL } from '../config';
import { mockAuthHeaders } from '../utils/mockAuth';

// Signup flow API client. Sessions ride on the `onward_session` cookie
// (axios withCredentials is globally set in profileManagerService.js).

export const saveSignupDraft = async (patch) => {
  const res = await axios.post(`${API_URL}/api/signup/save-draft`, patch, {
    headers: { ...mockAuthHeaders() },
  });
  return res.data;
};

export const completeSignup = async (submission) => {
  const res = await axios.post(`${API_URL}/api/signup/complete`, submission, {
    headers: { ...mockAuthHeaders() },
  });
  return res.data;
};

// Reuses the existing heavy resume parser. v1 only uses the parsed name
// (if populated and user's name field is still empty) — the full profile
// result is ignored at signup time. Will likely be split into a
// signup-lightweight extractor in v1.1 once we have real usage data.
export const uploadResumeForSignup = async (file) => {
  const form = new FormData();
  form.append('file', file);
  const res = await axios.post(
    `${API_URL}/api/automation/parse-resume-to-profile`,
    form,
    { headers: { ...mockAuthHeaders() } }
  );
  return res.data;
};

// False-door click tracking for the "Sign up with LinkedIn (Coming Soon)"
// button. Reuses the feature-requests endpoint so vote counts live in
// the same place as the rest of the Coming-Soon features.
export const trackLinkedinClick = async () => {
  try {
    await axios.post(
      `${API_URL}/api/feature-requests/upvote`,
      { feature_key: 'signup.linkedin_click' },
      { headers: { ...mockAuthHeaders() } }
    );
  } catch (err) {
    // Non-critical — don't break the UX on a tracking failure
    console.warn('LinkedIn click tracking failed:', err);
  }
};
